var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-btn-play-pause" },
    [
      _c(
        "transition",
        { attrs: { name: "fade-superfast", mode: "out-in" } },
        [
          _c(
            "w-btn-icon",
            _vm._b(
              {
                key: _vm.action,
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.togglePause.apply(null, arguments)
                  },
                },
              },
              "w-btn-icon",
              { size: _vm.size, noHover: _vm.noHover },
              false
            ),
            [_c(_vm.icon, { tag: "component", attrs: { title: _vm.title } })],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }